import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Typography,
	Grid
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	container: {
		paddingTop: "50%",
		[theme.breakpoints.up('sm')]: {
			paddingTop: "40%",
		},
		[theme.breakpoints.up('md')]: {
			paddingTop: "35%",
		},
	},
}));

function FullscreenMessage(props) {
	let classes = styles(),
		{ message, style, msgClassName } = props;

	return (
		<Grid className={classes.container} container direction="column" alignItems="center" justify="center" style={style}>
			<Grid item>
				<Typography variant="h5" color="textSecondary" className={msgClassName}>{message}</Typography>
			</Grid>
		</Grid>
	);
}

FullscreenMessage.propTypes = {
	message: PropTypes.string,
	style: PropTypes.object,
	msgClassName: PropTypes.string
};

export default FullscreenMessage;
